// extracted by mini-css-extract-plugin
export default {"container":"SuspenseLoader_container__4wrEf"};